import { compact } from '../../../helpers/compact';
import { DocumentType } from '../../../types/document';
import { HomePage } from '../../../types/page';
import { REGION } from '../../../types/filters';
import { toBoolean } from '../fields/boolean';
import { toRegionType } from '../mapping/region';
import { processSlices } from '../slices';
import homeSliceMapper from '../slices/home';
import { pageEntity } from './internal';

const processCustomSlices = processSlices(homeSliceMapper);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const processHomePage = (entity: any): HomePage =>
  compact({
    uid: toRegionType(entity.data?.main_region) || REGION.NATIONAL,
    type: DocumentType.HOME,
    region: toRegionType(entity.data?.main_region) || REGION.NATIONAL,
    displayRegionalMenu: toBoolean(entity.data?.main_display_regional),
    body: processCustomSlices(entity.data?.body_slices),
  });

const Home = pageEntity<HomePage>(DocumentType.HOME, {
  processStrategy: processHomePage,
});

export default Home;
